import { createRoot } from 'react-dom/client';
import App from './app/app';
import { CommonProviders } from './app/providers';
import { DeveloperTools } from './app/DeveloperTools';
import { ErrorBoundary } from './app/errorBoundary/ErrorBoundary';
import { EnvironmentBadge } from './app/components/atoms/EnvironmentBadge';
import { StrictMode, Suspense } from 'react';
import { CommonLoader } from './app/components/atoms/CommonLoader';

// Handle chunk load errors, reload the page
window.addEventListener(
  'error',
  (event) => {
    const isChunkLoadFailed = /Failed to fetch dynamically imported module|Loading chunk [\d]+ failed/.test(
      event.message,
    );

    if (isChunkLoadFailed) {
      window.location.reload();
    }
  },
  true,
);

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Suspense fallback={<CommonLoader />}>
      <ErrorBoundary>
        <CommonProviders>
          <EnvironmentBadge />
          <DeveloperTools />
          <App />
        </CommonProviders>
      </ErrorBoundary>
    </Suspense>
  </StrictMode>,
);
